import { TFunction } from 'i18next';

export type DisconnectionReason = {
  value: string;
  salesforceCode: string;
};

export enum OptionType {
  Main = 'main',
  Other = 'other',
}

// Mapping between options and Salesforce codes for satellite plans can be found here: https://wiki.viasat.com/spaces/SWEXP/pages/1379961040/My+Viasat+Copy+Deck
export function getSurveyOptions(t: TFunction, optionType: OptionType, hasPreinstall: boolean, hasFiber: boolean) {
  const activeFiberKey = `survey.fiber.active.reason.list.${optionType}`;
  const activeFiberOptions = getSurveyOptionsByKey(t, activeFiberKey);

  const preinstallFiberKey = `survey.fiber.preinstall.reason.list.${optionType}`;
  const preinstallFiberOptions = getSurveyOptionsByKey(t, preinstallFiberKey);

  const activeSatelliteKey = `survey.satellite.active.reason.list.${optionType}`;
  const activeSatelliteOptions = getSurveyOptionsByKey(t, activeSatelliteKey);

  const preinstallSatelliteKey = `survey.satellite.preinstall.reason.list.${optionType}`;
  const preinstallSatelliteOptions = getSurveyOptionsByKey(t, preinstallSatelliteKey);

  const fiberOptions = hasPreinstall ? preinstallFiberOptions : activeFiberOptions;

  const satelliteOptions = hasPreinstall ? preinstallSatelliteOptions : activeSatelliteOptions;

  return hasFiber ? fiberOptions : satelliteOptions;
}

function getSurveyOptionsByKey(t: TFunction, translationKey: string): DisconnectionReason[] {
  const asArray = { returnObjects: true }; // Returns an array of strings
  // Necessary type casting since TypeScript does not recognize the return type of the t function here
  return t(translationKey, asArray) as unknown as DisconnectionReason[];
}

export function getSurveyOptionValues(reasons: DisconnectionReason[]) {
  return reasons.map((reason) => reason.value);
}
